<template>
  <div class="page">
    <div class="info">
      <div class="title">Staking NFT</div>
      <div class="icon">
        <img :src="img_url" v-if="img_url" />
      </div>
      <div class="token">#{{ token_id }}</div>
      <div class="level">Lv.{{ level }}</div>
      <img
        class="quality"
        :src="
          require(`@/assets/images/YuliApp/common/Yuli/type/${type_name}.png`)
        "
        v-if="type_name"
      />
      <img
        class="type"
        :src="
          require(`@/assets/images/YuliApp/common/Yuli/property/icon_${quality_name}.png`)
        "
        v-if="quality_name"
      />
    </div>
    <div class="tips">
      <div class="text">
        Congrats!You have redeemed your staking Yuli And your ART and EXP
        rewards has been claimed in the meantime
      </div>
      <div class="close" @click="handleClose">
        <div class="close-text">Continue</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onBeforeMount, onMounted, ref, getCurrentInstance } from "vue";
import appBridging from "@/utils/appBridging.js";
import store from "@/store";
import { getYOG2StakingRecord, getYuliList } from "@/api/staking.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import {
  PASSCARD_INCOME_MAP,
  ART_INCOME_MAP,
  YULI_QUALITY_TYPE_MAP,
  getPasscardIncomByDay,
  ARG_COST_MAP,
} from "@/components/YuliStaking/constants/incomeMap.js";
import { getDiffDays } from "@/utils/date.js";
import { floatMul } from "@/utils/math.js";
import { tofix } from "@/utils/utils";
import {
  YULI_ROLE_TYPE_MAP,
  YULI_ROLE_PROPERTY_TYPE_MAP,
  TIME_TYPE,
  TIME_TYPE_GROUP,
} from "@/components/YuliStaking/constants/type.js";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler(value) {
        this.yuliData = value;
        this.handleInit(value);
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const yuliData = ref(null);

    const img_url = ref("");
    const token_id = ref("");
    const level = ref(0);
    const quality = ref("");
    const quality_name = ref("");
    const type = ref("");
    const type_name = ref("");

    /**
     * 处理数据
     */
    const handleInit = (data) => {
      const _image = data?.image;
      const extension_attribute = data?.extension_attribute;
      const _level = extension_attribute?.level;
      const _token_id = data?.token_id || extension_attribute?.token_id;
      const role_type = extension_attribute?.role_type;
      const role_type_name = YULI_ROLE_PROPERTY_TYPE_MAP[role_type] || "";
      const role_property = extension_attribute?.role_property;
      const role_property_name = YULI_ROLE_TYPE_MAP[role_property] || "";

      img_url.value = _image;
      token_id.value = _token_id;
      level.value = _level;
      quality.value = role_property;
      quality_name.value = role_property_name;
      type.value = role_type;
      type_name.value = role_type_name;
    };

    /**
     * 跳转关闭
     */
    const handleClose = () => {
      emit("onClose");
    };

    return {
      localesPackage,
      localesEnv,
      img_url,
      token_id,
      level,
      quality,
      quality_name,
      type,
      type_name,
      handleInit,
      handleClose,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: initial;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transform-origin: top;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 11px;
  margin-bottom: 20px;
  background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/bg.png");

  .title {
    color: #ffffff;
    font-family: "Tomorrow";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 19.2px;
    text-transform: uppercase;
    position: absolute;
    top: 14px;
  }

  .info {
    width: 355px;
    height: 549px;

    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .icon {
      width: 330px;
      height: 330px;
      top: 83px;
      position: absolute;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .token,
    .level {
      color: #aae1ff;
      font-family: "Inter";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    .token {
      position: absolute;
      top: 56px;
      left: 30px;
    }

    .level {
      position: absolute;
      top: 56px;
      left: 156px;
    }

    .quality,
    .type {
      width: 24px;
      height: 24px;
      background-position: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    .quality {
      position: absolute;
      top: 53px;
      right: 60px;
    }
    .type {
      position: absolute;
      top: 53px;
      right: 30px;
    }
  }

  .tips {
    width: 291px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 16px;

    .text {
      color: #aae1ff;
      font-family: "Inter";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 17px;
      font-size: 13px;
    }

    .close {
      width: 236px;
      height: 44px;
      background-image: url("~@/assets/images/YuliApp/YuliStaking/myStaking/btn_claim.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &-text {
        color: #0f193b;
        text-align: center;
        font-family: "Tomorrow";
        font-size: 16px;
        font-weight: 500;
        line-height: 37.5px;
      }
    }
  }
}
</style>
